import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import IconButton from '@/components/Button/IconButton';
import { useModalContext } from '@/components/Modal/Modal';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import { ModalStyle } from '@/styles/style';

type Props = {
  children: React.ReactNode;
  title: string;
  description: string;
  error: string | null;
  connectButtonDisabled?: boolean;
  handleConnectWorkspace: () => Promise<void>;
  tooltip?: ReactNode;
};

export const CompoundConnectModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const { handleConnectWorkspace, error, connectButtonDisabled } = props;

  return (
    <ModalStyle className="flex flex-col w-155 p-8">
      <div className="flex gap-2 justify-between items-center">
        <Heading type="h2">{props.title}</Heading>
        <IconButton
          icon={<CloseOutlined />}
          outlined={false}
          sizeType="m"
          onClick={closeModal}
        />
      </div>
      <Space h="8px" />
      <TooltipV2 tooltipNode={props.tooltip}>
        <Typo type="label1" className="text-gray-600">
          {props.description}
          {props.tooltip && (
            <InfoCircleOutlined className="text-gray-600 size-4.4 ml-1" />
          )}
        </Typo>
      </TooltipV2>
      <Space h="32px" />
      {props.children}
      <Space h="24px" />
      <Flex j="space-between">
        <Typo type="label2" className="text-destructive">
          {error || ''}
        </Typo>
        <Button
          sizeType="m"
          className="py-2 px-4"
          onClick={handleConnectWorkspace}
          disabled={connectButtonDisabled}
        >
          Connect
        </Button>
      </Flex>
    </ModalStyle>
  );
};
